import { debounce } from 'lodash'

export default {
    data() {
        return {
            ready: false,
            workshops: [],
            localOptions: {
                sortBy: this.$route.query.sort ? [this.$route.query.sort] : ['subscriptions_count'],
                sortDesc: this.$route.query.direction ? [this.$route.query.direction == 'desc'] : [false],
                mustSort: false,
                multiSort: false,
                page: 1,
                itemsPerPage: 24
            },
            search: {
                ...(this.$route.query.search ? JSON.parse(this.$route.query.search) : {}),
                active: true,
            },
            total: 0,
            loading: false,
            loadingMore: false,
            hasMore: true,
            allDepartments: [],
            allCities: [],
            departmentsLoading: false,
            citiesLoading: false,
            slider: [],
            professionalsNames: [],
            professionalsNamesLoading: false,
            cache: {
                departments: null,
                cities: null,
                professionals: null
            }
        }
    },
    computed: {
        options: {
            get() {
                return this.localOptions
            },
            set(newValue) {
                this.localOptions = newValue
            }
        }
    },
    methods: {
        refreshPagination(reset = false) {
            if (reset) {
                this.workshops = []
                this.localOptions.page = 1
                this.hasMore = true
                this.loading = true
            } else {
                this.loadingMore = true
            }

            const queries = {
                sort: this.options.sortBy,
                direction: (this.options.sortDesc?.length ? this.options.sortDesc[0] : false) ? 'desc' : 'asc',
                search: JSON.stringify(this.search),
                with: [
                    'user',
                    'meetings:id,start,end',
                    'partner.logo:id,path'
                ],
                select: 'id,name,description,type,active,user_id,partner_id,created_at,updated_at,subscriptions_count',
                per_page: this.options.itemsPerPage,
                page: this.localOptions.page,
                without: ['user.role_name', 'user.code']
            }

            this.$store.dispatch('workshopsRequest', queries)
                .then(result => {
                    this.total = result.meta.total
                    if (reset) {
                        this.workshops = result.data
                    } else {
                        this.workshops = [...this.workshops, ...result.data]
                    }
                    this.hasMore = this.workshops.length < this.total
                    this.ready = true
                })
                .catch((err) => {
                    if (err.response.status != 403)
                        this.$store.dispatch('setErrors', err.response.data)
                })
                .finally(() => {
                    this.loadingMore = false
                    this.loading = false
                })
        },
        handleScroll() {
            const scrollPosition = window.innerHeight + window.scrollY
            const documentHeight = document.documentElement.offsetHeight
            const threshold = 100

            if (scrollPosition >= documentHeight - threshold && !this.loadingMore && this.hasMore) {
                this.localOptions.page++
                this.refreshPagination()
            }
        },
        initAdvancedSearch() {
            this.fetchDepartments()
            this.fetchCities()
            this.fetchProfessionalsNames()
        },
        fetchDepartments() {
            if (this.cache.departments) {
                this.allDepartments = this.cache.departments
                return
            }

            this.departmentsLoading = true
            this.$axios.get('https://geo.api.gouv.fr/departements')
                .then((resp) => {
                    this.allDepartments = resp.data
                    this.cache.departments = resp.data
                }).finally(() => {
                    this.departmentsLoading = false
                })
        },
        fetchCities() {
            this.citiesLoading = true
            this.$axios.get('https://geo.api.gouv.fr/communes')
                .then((resp) => {
                    this.allCities = resp.data
                }).finally(() => {
                    this.citiesLoading = false
                })
        },
        fetchProfessionalsNames() {
            this.professionalsNamesLoading = true
            this.$store.dispatch('professionalsNamesRequest')
                .then((result) => {
                    this.professionalsNames = result.data
                })
                .catch((err) => {
                    this.$store.dispatch('setErrors', "Une erreur est survenue lors de la récupération des professionnels")
                })
                .finally(() => {
                    this.professionalsNamesLoading = false
                })
        },
        initLogos() {
            // Reset slider on each load
            this.slider = []
            
            this.$store.dispatch("partnersRequest", { 
                with: ["logo"], 
                search: JSON.stringify({"active": 1}),
                per_page: 0  // Get all active partners (0 = no limit)
            }).then((result) => {
                const apiUrl = process.env.VUE_APP_API_URL
                const shuffledPartners = this.shuffleArray(result.data)
                shuffledPartners.forEach((partner) => {
                    if (partner.logo) {
                        let url = `${apiUrl}/storage/${partner.logo.path}`
                        this.slider.push(url)
                    }
                })
            }).catch((error) => {
                console.log('Error loading partner logos:', error)
            })
        },
        shuffleArray(array) {
            const shuffled = [...array]
            for (let i = shuffled.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1))
                ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
            }
            return shuffled
        },
        updateOptions(newOptions) {
            // Forcer la réactivité en remplaçant complètement l'objet
            this.localOptions = { ...newOptions }
        }
    },
    created() {
        this.debouncedRefresh = debounce(() => this.refreshPagination(true), 300)
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    watch: {
        $route() {
            this.refreshPagination(true)
        },
        search: {
            handler() {
                if (!this.$route.to && !this.$route.from) {
                    this.$router.replace({
                        query: {
                            search: JSON.stringify(this.search),
                        }
                    }).catch(e => {})
                }
            },
            deep: true
        },
        'options.sortBy': {
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                    console.log('sortBy changed:', oldVal, '->', newVal)
                    this.refreshPagination(true)
                }
            },
            deep: true
        },
        'options.sortDesc': {
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                    console.log('sortDesc changed:', oldVal, '->', newVal)
                    this.refreshPagination(true)
                }
            },
            deep: true
        }
    }
} 